// src/components/ArtCard.js
import { useDrag } from 'react-dnd';
import { shopifyClient } from './shopify';

export default function ArtCard({ art }) {
  const [{ isDragging }, drag] = useDrag(
    () => ({
      type: 'ART_CARD',
      item: { art },
      collect: (monitor) => ({
        isDragging: !!monitor.isDragging(),
      }),
    }),
    [art]
  );

  function handleAddToCart(variantId) {
    window.parent.postMessage(
      {
        type: 'ADD_TO_SHOPIFY_CART',
        variantId,
        quantity: 1,
      },
      '*'
    );
  }


  return (
    <div
      ref={drag}
      className="card"
      style={{
        width: '100%',
        height: '100%',
        opacity: isDragging ? 0.4 : 1,
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'space-between',
        borderRadius: '3px',
        backgroundColor: '#ffffff90',
        boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
        overflow: 'hidden',
        boxSizing:'border-box',
        padding:0,
        margin:0,
      }}
    >
      {/* Image */}
      <div style={{
        width:'75%',
        aspectRatio: '6 / 8.3',
        padding: '0.2em 0.3em',
        overflow: 'hidden',
      }}>
        <img
          src={art.img}
          alt={art.name}
          style={{
            width: '100%',
            height: 'auto',
            objectFit: 'contain',
            display: 'block',
            maxWidth: '100%',
            maxHeight: '100%'
          }}
        />
      </div>

      {/* Metadata */}
      <div style={{
        padding: '0em 0em',
        fontSize: '0.5em',
        display: 'flex',
        justifyContent: 'space-evenly',
        textAlign:'center',
        alignItems: 'center',
        textWrap:'nowrap',
        overflow:'hidden'
      }}>
        <div style={{ fontWeight: 600, marginRight: '.3em'}}>{art.name}</div>
      </div>

      {/* Add to cart */}
      <button
        onClick={() => handleAddToCart(art.shopify)}
        style={{
          padding: '0.4em 1em',
          backgroundColor: '#ffe400',
          color: '#000',
          border: 'none',
          borderTop: '0px solid #ccc',
          cursor: 'pointer',
          fontSize: '0.5em',
        }}
      >
        + add to cart
      </button>
    </div>
  );
}
